module.exports = __webpack_public_path__ + "static/media/11_1440.649b9175.jpeg";